export default __webpack_public_path__ + "static/media/Jawwad.852558e7.jpg";